import React, { useEffect } from 'react'
import './PreviewMenu.scss'
import CarNav from '../../../../assets/images/Car-Nav.png'
import HeartNav from '../../../../assets/images/Heart-Nav.png'
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCartModal } from '../../../../../../store/slices/contextUI'
import CartModal from '../../../../ModalWindows/CartModal/CartModal'
import { useNavigate, useParams } from 'react-router'
import { Box, Button, Modal, TextField } from '@mui/material'
import { useForm } from 'react-hook-form'
import TelegIcon from '../../../../assets/images/logos_telegram.svg'
import WhatsUp from '../../../../assets/images/WhatsupIconLogin.svg'
import useSendLog from '../../../../../../hooks/useSendLog'
import { mainApi } from '../../../../../../store/services/mainApi'
import { debounce } from 'lodash'

const PreviewMenu = () => {
    const showCart = useSelector(state => state.contextUI.uiModal.cartModal)
    const [showMenu, setShowMenu] = useState(false)
    const allItemCart = useSelector(state => state.allItemsCart.allItemsCart)
    const allItemSaleCart = useSelector(state => state.saleCart.saleCart)
    const dispatch = useDispatch()
    const tradeNameParams = useParams().tradeName
    const platformParam = useParams().platform
    const navigate = useNavigate()
    const { register, handleSubmit, reset, control, setValue } = useForm();
    const userAcc = useSelector(state => state.accountData.userAcc)
    const localStorageData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
    const [tradeName, setTradeName] = useState(localStorageData ? localStorageData?.tradeNameCode : userAcc?.tradeName !== '' ? userAcc.tradeName : '')

    const handleTardeNameConfirm = () => {
        localStorage.setItem('userData', JSON.stringify({
            ...localStorageData,
            tradeNameCode: tradeName,
            employee: tradeName == 'TPOITD' ? true : false,
        }))
        navigate(`/category/${tradeName}`)
        setShowMenu(false)
    }
    const handleClickCartPersonal = useSendLog('Click on cart in personal links', {});
    const handleClickCart = useSendLog('Click on cart', {});

    const isSalePage = location.pathname.includes('/group');
    // const saleIdParams = useParams().saleId

    const [findCodePhoneValue, setFindCodePhoneValue] = useState('');
    const [findCodePhoneValueString, setFindCodePhoneValueString] = useState(''); 

    useEffect(() => {
        // 1. Set a timer to update the debounced state after 300ms.
        const handler = setTimeout(() => {
        // This runs only once the typing has stopped for 300ms.
        setFindCodePhoneValueString(findCodePhoneValue);
        }, 300);

        return () => {
        clearTimeout(handler);
        };
    }, [findCodePhoneValue]); 

    const skipApi = !findCodePhoneValueString || findCodePhoneValueString?.length < 5;

    const { data: findTradeNameByPhone, isLoading: findTradeNameByPhoneLoading } = mainApi.useGetContactTradeNameByPhoneQuery(
        findCodePhoneValueString,
        { skip: skipApi }
    );


	return (
    <>  
        {showCart && 
        <CartModal/>
        // <PreviewCart/>
        }
        <div className='previewNav__menu'>
            {allItemCart?.length > 0 && !isSalePage && <div className='previewNav__menu__count'>{allItemCart?.length}</div>}
            {allItemSaleCart?.length > 0 && <div className='previewNav__menu__count'>{allItemSaleCart?.length}</div>}
            <img 
                src={CarNav} 
                onClick={() => {
                    if (!isSalePage) {
                        if (tradeNameParams !== undefined) {
                            if (platformParam !== undefined) {
                                navigate(`/newOrder/${platformParam}/${tradeNameParams}`)
                                handleClickCartPersonal()
                            } else {
                                navigate(`/newOrder/${tradeNameParams}`)} 
                                window.scrollTo(0, 0)
                                handleClickCartPersonal()
                        } else {
                            dispatch(setCartModal(!showCart))
                            handleClickCart()
                        }
                    } else {
                        navigate('/group/newOrder')
                    }
                }
                }/>
            <img src={HeartNav} onClick={() => tradeName ? navigate(`/category/${tradeName}`) : setShowMenu(!showMenu)}/>
            {/* <img src={CalendarNav}/> */}
        </div>
        {showMenu && 
        <Modal open={showMenu} onClose={() => setShowMenu(!showMenu)}>
            <Box className='NewOrderPage__mainEditOrder__sendOrder__modal'
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                display: 'flex',
                flexDirection: 'column',
                outline: 'none',
                border: '3px solid #5FC56E',
                fontFamily: 'Montserrat',
                fontSize: '17px',
                color: '#5FC56E',
                borderRadius: 6,
                gap: 2,
                p: 4,
            }}>
                <span>Para recibir tu lista de productos favoritos, entroduzca el código de tu local:</span>
                Dime tú número de WhatsApp, o el nombre del restaurante o empresa
                <TextField
                    onChange={(e) => setFindCodePhoneValue(e.target.value)}
                    value={findCodePhoneValue}
                    fullWidth
                    variant='outlined'
                    placeholder='Número de WhatsApp o nombre de restaurante'
                />

                {findCodePhoneValue?.length >= 5 && <div style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    tu código: {findTradeNameByPhone?.length > 0 && findCodePhoneValue?.length >= 5 ?
                    Array.from(new Set(findTradeNameByPhone?.map((el) => el?.tradeName)))?.map((el, index) => <span onClick={() => setTradeName(el)} 
                        style={{ border: '1px solid #5fc56e', borderRadius: '5px', padding: '5px 10px', background: tradeName == el ? '#5fc56e' : '#fff', color: tradeName == el ? '#fff' : '#5fc56e', cursor: 'pointer' }}
                    >
                        {el}
                    </span>)
                    : 'No comerciar con nombre'}
                </div>}
                {/* <TextField
                    onChange={(e) => setTradeName((e.target.value)?.toUpperCase())}
                    value={tradeName}
                    fullWidth
                    variant='outlined'
                    placeholder='Apunta tu código aquí'
                /> */}
                    
                <Button 
                    variant='contained' 
                    onClick={() => handleTardeNameConfirm()}
                    color="success"
                    disabled={tradeName === ''}
                >
                    Continuar
                </Button>
                <span>No lo sabes? <br />
    Pídelo porfavor aquí</span>
                <div style={{display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center'}}>
                    <img src={TelegIcon} width={50} alt="Telegram" onClick={() => {window.open('https://t.me/tpobcn', '_blank')}}/>
                    <img src={WhatsUp} width={60} alt="Whatsapp" onClick={() => {window.open('https://wa.me/34642868541', '_blank')}}/>
                </div>
            </Box>
        </Modal>}
    </>
  )
}

export default PreviewMenu